import { Button, Card, Col, Row, Typography, Space, Input, Table } from "antd";
import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import SessionsModal from "./Model";
import moment from "moment";
import Meta from "antd/es/card/Meta";

const Sessions = () => {
  const { Title } = Typography;

  const [searchText, setSearchText] = useState("");


  const recordedSessions = [
    {
      key: "1",
      thumbnail:
        "https://cdn.pixabay.com/photo/2017/11/10/05/34/play-2935460_640.png",
      title: "Introduction to HTML and CSS",
      date: "2025-01-10",
      description:
        "Learn the basics of HTML and CSS to build simple web pages.",
    },
    {
      key: "2",
      thumbnail:
        "https://cdn.pixabay.com/photo/2017/11/10/05/34/play-2935460_640.png",
      title: "JavaScript Essentials",
      date: "2025-01-15",
      description:
        "Understand the fundamentals of JavaScript for web development.",
    },
    {
      key: "3",
      thumbnail:
        "https://cdn.pixabay.com/photo/2017/11/10/05/34/play-2935460_640.png",
      title: "React Basics: Components and State",
      date: "2025-01-20",
      description:
        "A beginner-friendly session on building React components and managing state.",
    },
    {
      key: "4",
      thumbnail:
        "https://cdn.pixabay.com/photo/2017/11/10/05/34/play-2935460_640.png",
      title: "Advanced CSS: Flexbox and Grid",
      date: "2025-01-25",
      description: "Master layout techniques using Flexbox and Grid in CSS.",
    },
    {
      key: "5",
      thumbnail:
        "https://cdn.pixabay.com/photo/2017/11/10/05/34/play-2935460_640.png",
      title: "Building REST APIs with Node.js",
      date: "2025-01-30",
      description:
        "Learn how to create RESTful APIs using Node.js and Express.",
    },
    {
      key: "6",
      thumbnail:
        "https://cdn.pixabay.com/photo/2017/11/10/05/34/play-2935460_640.png",
      title: "Deploying Websites with Netlify",
      date: "2025-02-05",
      description:
        "A step-by-step guide to deploying static websites on Netlify.",
    },
  ];
  const sessions = [
    {
      id: 1,
      name: 'CSS 002: Selectors',
      date: '29/07/2025'
    },
    {
      id: 2,
      name: 'CSS 003: Advanced Selectors',
      date: '29/07/2025'
    },
    {
      id: 3,
      name: 'CSS 003: CSS Events (Upcoming)',
      date: '29/07/2025'
    }
  ];

  const [selectedSession, setSelectedSession] = useState(sessions[1])

  // Handle search
  const handleSearch = (e) => {
    setSearchText(e.target.value.toLowerCase());
  };

  // Filtered data based on search text
  const filteredData = recordedSessions.filter((item) =>
    item.title.toLowerCase().includes(searchText)
  );

  // Columns definition for the table
  const columns = [
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
      render: (src) => (
        <div className="flex justify-center items-center">
          <img src={src} alt="Thumbnail" className="w-12 h-12 rounded-md" />
        </div>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => <span className="text-gray-800">{text}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (date) => <span className="text-gray-600">{date}</span>,
    },
  ];



  return (
    <>
      <div className="mb-6">
        <Title level={4}>Sessions</Title>
      </div>
      <Card>
        <Row gutter={[16, 16]}>
          <Col span={16} className="grid justify-center bg-slate-600 rounded-2xl" >
            <div className="relative h-[20rem] aspect-video  bg-slate-500 flex items-center justify-center">
              <SessionsModal isLive={selectedSession.id === 2}
                isDisabled={selectedSession.id === 3}
                session={selectedSession} />
            </div>
          </Col>
          <Col span={8}>
            <Space
              direction="vertical"
              size="middle"
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                gap: '1rem'
                // justifyContent: "space-between",
              }}
            >
              {sessions.map(({ id, name, date }, index) => {
                return <Card
                  onClick={() => setSelectedSession({ id, name, date })}
                  className={`cursor-pointer overflow-hidden flex h-20 ${id === selectedSession.id ? 'border-blue-500' : ''}`}
                  bodyStyle={{ padding: '0px' }}
                  cover={<img alt="example" src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png" className="h-full aspect-square object-cover aspect-square" />}
                >
                  <Meta title={name} description={date} className={`max-w-60  p-4 ${id === selectedSession.id ? 'text-white' : ''}`} />
                </Card>
              }
              )}
            </Space>
          </Col>
        </Row>
      </Card>
      <div className="mt-6">
        <Title level={4}>Recorded Sessions</Title>
        {/* <TableWithPagination
          url="ttps://dummyjson.com/users" // Replace with your API endpoint
          columns={columns}
        /> */}
        <div className="p-6">
          <div className="mb-4">
            <Input
              placeholder="Search by title"
              prefix={<SearchOutlined />}
              onChange={handleSearch}
              className="rounded-md"
            />
          </div>
          <Table
            columns={columns}
            dataSource={filteredData}
            bordered
            pagination={{ pageSize: 5 }}
            className="shadow-md rounded-lg"
          />
        </div>
      </div>
    </>
  );
};

export default Sessions;
